var _ellipse, _ellipse2, _ellipse3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNorneAksjehandelIkon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 200 200"
}, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 37.37,
  cy: 114.2,
  fill: "#2a2a2a",
  rx: 6.68,
  ry: 6.73
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 93.97,
  cy: 93.58,
  fill: "#2a2a2a",
  rx: 6.68,
  ry: 6.73
})), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 192.76,
  cy: 46.16,
  fill: "#2a2a2a",
  rx: 6.68,
  ry: 6.73
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2a2a2a",
  d: "M196.49 158.28H.56l33.66-32.84a4.37 4.37 0 0 1 6-.1l15.06 13.78a1.35 1.35 0 0 0 1.87 0l33.92-34.2a4.35 4.35 0 0 1 5.79-.34L121 123.64a1.36 1.36 0 0 0 1.79-.1l66.29-66.17a4.28 4.28 0 0 1 3.07-1.28 4.39 4.39 0 0 1 4.35 4.39Zm-188.56-3h185.56v-94.8a1.42 1.42 0 0 0-.4-1 1.36 1.36 0 0 0-1-.41 1.32 1.32 0 0 0-1 .4l-66.29 66.17a4.34 4.34 0 0 1-5.77.33L95 106.89a1.35 1.35 0 0 0-1.8.11l-33.94 34.19a4.33 4.33 0 0 1-6 .14l-15.09-13.77a1.35 1.35 0 0 0-1.85 0Z"
})));
export default SvgNorneAksjehandelIkon;